export default "__VITE_ASSET__5312f850__"